var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('base-error',[_c('template',{slot:"heading"},[_vm._v(_vm._s(_vm.title))]),_c('template',{slot:"text"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.message)}})])],2)}
var staticRenderFns = []

export { render, staticRenderFns }